import React from 'react';
import { Typography, Checkbox, Spin } from 'antd';

import { translate } from '@portal/services/i18n';
import { moneyFormat } from '@portal/utils/format';
import AdvancedModal from '@portal/components/AdvancedModal/AdvancedModal';

interface OverdraftConfirmationModalProps {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  overdraftAmount: number;
  optinRequired?: boolean;
  optinChecked?: boolean;
  onOptinChange?: (checked: boolean) => void;
  loading?: boolean;
}

const OverdraftConfirmationModal: React.FC<OverdraftConfirmationModalProps> = ({
  visible,
  onConfirm,
  onCancel,
  overdraftAmount,
  optinRequired = false,
  optinChecked = false,
  onOptinChange,
  loading = false,
}) => {
  return (
    <AdvancedModal
      visible={visible}
      size="medium"
      title={translate('MODALS.OVERDRAFT_CONFIRMATION.TITLE')}
      onClose={onCancel}
      actions={[
        {
          label: translate('MODALS.OVERDRAFT_CONFIRMATION.CANCEL_TRANSACTION'),
          onClick: onCancel,
          type: 'cancel',
        },
        {
          label: translate('MODALS.OVERDRAFT_CONFIRMATION.CONTINUE'),
          onClick: onConfirm,
          disabled: loading || (optinRequired && !optinChecked),
          type: 'ok' as const,
        },
      ]}
    >
      <Spin spinning={loading}>
        <div style={{ padding: '16px 0' }}>
          <Typography.Paragraph>
            {translate('MODALS.OVERDRAFT_CONFIRMATION.DESCRIPTION', {
              overdraftAmount: moneyFormat(overdraftAmount),
            })}
          </Typography.Paragraph>
          {optinRequired ? (
            <div style={{ margin: '16px 0' }}>
              <Checkbox
                checked={optinChecked}
                onChange={(e) => onOptinChange?.(e.target.checked)}
                disabled={loading}
              >
                {translate('MODALS.OVERDRAFT_CONFIRMATION.OPTIN_CHECKBOX')}
              </Checkbox>
            </div>
          ) : null}
        </div>
      </Spin>
    </AdvancedModal>
  );
};

export default OverdraftConfirmationModal;
